import { Button } from 'components/common/BackToResultButton/components';
import { CSSProperties } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import useIsMobile from 'hooks/use-is-mobile';
import { useNavigate } from 'react-router-dom';

type Props = {
  color?: CSSProperties['color'];
};

export default function BackToResultButton(props: Props): JSX.Element {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const onBackClick = () => navigate('/home');

  return (
    <Button
      className='back-button'
      color={props.color}
      type='link'
      icon={<LeftOutlined className='back-button-icon' />}
      onClick={onBackClick}
    >
      {isMobile ? 'Back' : 'Back to all results'}
    </Button>
  );
}
